<template>
  <div class="ev-page-container">
    <!-- Page Header -->
    <div class="ev-page-header">
      <h1 class="ev-page-title">
        <span class="ev-title-icon">🔧</span>
        Detaljan pregled
      </h1>
      <p class="ev-page-subtitle">
        Pregled i ručna korekcija dnevnih logova zaposlenog
      </p>
    </div>

    <!-- Filters Card -->
    <div class="ev-filters-card no-print">
      <div class="ev-filters-grid">
        <!-- Date Picker -->
        <div class="ev-filter-group">
          <label class="ev-filter-label">
            <span class="ev-filter-icon">📅</span>
            Izaberi dan
          </label>
          <date-picker
            v-model="time3"
            @input="dateChosen"
            type="date"
            class="ev-date-picker"
          ></date-picker>
        </div>

        <!-- Employee Picker -->
        <div class="ev-filter-group">
          <label class="ev-filter-label">
            <span class="ev-filter-icon">👤</span>
            Zaposleni
          </label>
          <vue-select
            class="ev-select"
            @option:selected="employeeSelected"
            type="text"
            label="name"
            :clearable="false"
            :options="employees"
            v-model="selectedEmployee"
            placeholder="Izaberite zaposlenog..."
          />
        </div>
      </div>
    </div>

    <!-- Info Badges -->
    <div v-if="dailyLogLoaded" class="ev-info-bar">
      <span class="ev-badge ev-badge-primary">
        👤 {{ selectedEmployee.name }} (ID: {{ selectedEmployee.id }})
      </span>
      <span class="ev-badge ev-badge-secondary">
        📅 {{ today.toLocaleDateString("sr-latn-cs") }}
      </span>
    </div>

    <!-- Osnovni log Section -->
    <div class="ev-table-section" v-if="dailyLogLoaded">
      <div class="ev-table-header">
        <h3 class="ev-table-title">
          <span class="ev-table-icon">📋</span>
          Osnovni log
        </h3>
      </div>
      <div class="ev-table-container">
        <daily-log-table
          :dailyLog="selectedDailyLog"
          title=""
        ></daily-log-table>
      </div>
    </div>

    <!-- Stop lista Section -->
    <div v-show="$store.state.auth.user.value1 !== 100">
      <div v-if="dailyLogLoaded" class="ev-section-stop-list">
        <stop-list
          @accessRemoteCreated="reload"
          :employee="selectedEmployee"
          :today="today"
          :tomorrow="tomorrow"
        />
      </div>

      <!-- Sve današnje akcije Section -->
      <div v-if="dailyLogLoaded">
        <div class="ev-table-section ev-section-actions">
          <div class="ev-table-header">
            <h3 class="ev-table-title">
              <span class="ev-table-icon">⚡</span>
              Sve današnje akcije
            </h3>
          </div>
          <div class="ev-table-container">
            <div
              v-for="dailyLog in selectedDailyLog"
              :key="dailyLog.employeeId"
            >
              <edit-daily-log
                title=""
                :selectedDailyLog="dailyLog"
                :employeeName="selectedEmployee.name"
                :showContextMenuDeactivate="true"
                :showContextMenuForceDeparture="true"
                :showManualLogAdd="true"
                :dontShowAllLogs="false"
                :isMultiselect="true"
                @accessRemoteCreated="reload"
              >
              </edit-daily-log>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Add new access log Section -->
    <div class="ev-card no-print" v-if="dailyLogLoaded">
      <h3 class="ev-section-title">
        <span class="ev-section-icon">➕</span>
        Ručna prijava
      </h3>
      <add-log-manual
        @accessRemoteCreated="reload"
        :date="time3"
        :employeeId="selectedEmployee.id"
        :isCustomDateSelectorVisible="true"
        :isButtonsVisible="false"
        :isRadioVisible="true"
        :employees="employees"
        :today="today"
        :tomorrow="tomorrow"
      />
    </div>

    <!-- Empty State -->
    <div class="ev-empty-state" v-if="!dailyLogLoaded">
      <div class="ev-empty-icon">🔧</div>
      <h3>Izaberite dan i zaposlenog</h3>
      <p>
        Odaberite datum i zaposlenog iz filtera iznad da biste vidjeli detaljan
        dnevni pregled.
      </p>
    </div>
  </div>
</template>

<script>
import UserService from "../../services/user.service";
import ReportService from "../../services/report.service";
import DatePicker from "vue2-datepicker";

import DailyLogTable from "../parts/DailyLogTable.vue";
import EditDailyLog from "../parts/EditDailyLog.vue";
import StopList from "../parts/StopList.vue";
import AddLogManual from "../parts/AddLogManual.vue";

export default {
  name: "ManualFix",

  components: {
    DatePicker,
    DailyLogTable,
    EditDailyLog,
    StopList,
    AddLogManual,
  },

  data() {
    return {
      time3: null,
      departments: [],
      employees: [],
      passedEmployeeId: null,
      selectedEmployee: null,
      selectedDailyLog: null,
      dailyLogLoaded: false,
      // refreshKey: null,
    };
  },

  mounted() {
    // load query params if any
    // date param
    const theDate = this.$route.query.date;
    if (theDate !== "undefined") {
      this.time3 = new Date(theDate);
    } else {
      this.time3 = new Date();
    }

    // employeeId param
    console.log(this.$route.query.employeeId);
    const theEmployeeId = this.$route.query.employeeId;
    if (theEmployeeId !== "undefined") {
      this.passedEmployeeId = theEmployeeId;
    }

    console.log("priviledge level");
    console.log(this.$store.state.auth.user.privilegesLevel);

    this.dateChosen(this.time3);
    this.getDepartments();
  },

  methods: {
    dateChosen(date) {
      console.log(this.time3);
      this.today = date;
      console.log("dateChosen");
      console.log(this.today);

      let nextDay1 = new Date(this.today);
      nextDay1.setDate(this.today.getDate() + 1);
      this.tomorrow = nextDay1;
      console.log(this.tomorrow);
      this.today.setHours(0, 0, 0, 0);
      this.tomorrow.setHours(0, 0, 0, 0);

      this.resetUi();
    },

    reload() {
      const emp = this.selectedEmployee;
      this.resetUi();
      this.employeeSelected(emp);
    },

    resetUi() {
      this.dailyLogLoaded = false;
      this.selectedEmployee = null;
    },

    employeeSelected(emp) {
      console.log(emp);
      this.resetUi();
      this.selectedEmployee = emp;
      this.getLog();
    },

    getDepartments() {
      UserService.getDepartments().then((response) => {
        // reset ui
        // console.log(response.data);
        this.departmentData = response.data;
        this.arrangeSectors(response.data);
        this.arrangeEmployees(response.data);

        // if there is passed by employeeId, select it
        if (this.passedEmployeeId) {
          this.selectedEmployee = this.employees.find(
            (e) => e.id == this.passedEmployeeId
          );
          this.employeeSelected(this.selectedEmployee);
        }
      });
    },

    arrangeSectors(data) {
      data.forEach((element) => {
        this.departments.push({
          name: element.name,
          id: element.departmentId,
        });
      });
      // console.log(this.departments);
    },

    arrangeEmployees(data) {
      data.forEach((element) => {
        element.employee.forEach((emp) => {
          this.employees.push({
            name: emp.firstName + " " + emp.lastName,
            id: emp.employeeId,
          });
        });
      });
    },

    getLog() {
      console.log("x");
      console.log(this.employees);
      ReportService.GetNormalizedAccessDataByTimeRange(
        this.today,
        this.tomorrow,
        this.selectedEmployee.id,
        null
      ).then((response) => {
        console.log(response.data);
        this.selectedDailyLog = response.data;
        console.log("this.selectedDailyLog");
        console.log(this.selectedDailyLog);
        this.dailyLogLoaded = true;
        console.log("this.selectedDailyLog.employeeId");
        console.log(this.selectedDailyLog.employeeId);
        // this.refreshKey = response.data[0].employeeId;
      });
    },
  },
};
</script>

<style scoped>
/* Info bar with badges */
.ev-info-bar {
  display: flex;
  gap: 12px;
  margin-bottom: var(--ev-spacing-lg);
  flex-wrap: wrap;
}

/* Section spacing */
.ev-section-stop-list {
  margin-bottom: var(--ev-spacing-lg);
}

.ev-section-actions {
  margin-bottom: var(--ev-spacing-lg);
}

/* Make child component tables fit inside the ev- sections */
.ev-table-container :deep(.base-demo) {
  margin: 0;
}

.ev-table-container :deep(.box) {
  box-shadow: none;
  border: none;
  padding: 0;
}

.ev-table-container :deep(.modal-header) {
  display: none;
}

.ev-table-container :deep(.subtitle) {
  display: none;
}

.ev-table-container :deep(.ex1) {
  display: none;
}
</style>
